import { z } from 'zod';
export function optionalEmailAfterTrim(maxLength, blank, invalidMessage) {
    return z
        .string()
        .trim()
        .max(maxLength)
        .transform((value) => (value === '' ? blank : value))
        .pipe(z.union([z.literal(blank), z.email(invalidMessage)]));
}
//# sourceMappingURL=optional-email-after-trim.js.map